"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMapping = void 0;
const tools_1 = require("@axiom-crypto/tools");
const halo2_lib_js_1 = require("@axiom-crypto/halo2-lib-js");
const utils_1 = require("../utils");
const data_1 = require("./data");
const buildMapping = (blockNumber, addr, mappingSlot) => {
    const nested = (keys) => {
        const mappingDepth = keys.length;
        if (mappingSlot instanceof halo2_lib_js_1.CircuitValue) {
            mappingSlot = (0, utils_1.getCircuitValue256FromCircuitValue)(mappingSlot);
        }
        if (keys.length === 0) {
            throw new Error("Keys must not be empty");
        }
        if (keys.length !== mappingDepth) {
            throw new Error("Keys length must match mapping depth");
        }
        if (mappingDepth < 1 || mappingDepth > 4) {
            throw new Error("mappingDepth range is [1,4]");
        }
        let mappingDepthCV = (0, utils_1.getCircuitValueConstant)(mappingDepth);
        let halo2LibValue256Keys = [];
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (typeof key === "string" || typeof key === "number" || typeof key == "bigint") {
                halo2LibValue256Keys.push((0, utils_1.getCircuitValue256Constant)(key));
            }
            else if (key instanceof halo2_lib_js_1.CircuitValue) {
                const convertedKey = (0, utils_1.getCircuitValue256FromCircuitValue)(key);
                halo2LibValue256Keys.push(convertedKey);
            }
            else {
                halo2LibValue256Keys.push(key);
            }
        }
        if (mappingDepthCV.value() === BigInt(0)) {
            throw new Error("Depth must be greater than 0");
        }
        let mappingSubquery = {
            blockNumber: blockNumber.number(),
            addr: addr.address(),
            mappingSlot: mappingSlot.hex(),
            mappingDepth: mappingDepthCV.number(),
            keys: halo2LibValue256Keys.map((key) => key.hex())
        };
        const hiLoKeys = halo2LibValue256Keys.map((key) => [key.hi(), key.lo()]);
        const flattened = hiLoKeys.reduce((acc, val) => acc.concat(val), []);
        const dataSubquery = { subqueryData: mappingSubquery, type: tools_1.DataSubqueryType.SolidityNestedMapping };
        return (0, data_1.prepData)(dataSubquery, [blockNumber, addr, mappingSlot.hi(), mappingSlot.lo(), mappingDepthCV, ...flattened]);
    };
    const key = (key) => {
        if (typeof key === "string" || typeof key === "number" || typeof key == "bigint") {
            key = (0, utils_1.getCircuitValue256Constant)(key);
        }
        else if (key instanceof halo2_lib_js_1.CircuitValue) {
            key = (0, utils_1.getCircuitValue256FromCircuitValue)(key);
        }
        return nested([key]);
    };
    const mapping = { nested, key };
    return Object.freeze(mapping);
};
exports.buildMapping = buildMapping;
//# sourceMappingURL=mapping.js.map